import storage from '../../utils/storage'

const STORAGE_KEY = 'tr_v3_report_contents_real'

export default {
  state: {
    contents: []
  },
  mutations: {
    SET_CONTENTS(state, list) {
      state.contents = list
      storage.set(STORAGE_KEY, list)
    },
    ADD_CONTENT(state, item) {
      state.contents.push(item)
      storage.set(STORAGE_KEY, state.contents)
    },
    UPDATE_CONTENT(state, item) {
      const idx = state.contents.findIndex(c => c.content_id === item.content_id)
      if (idx >= 0) {
        state.contents.splice(idx, 1, item)
        storage.set(STORAGE_KEY, state.contents)
      }
    },
    DELETE_CONTENT(state, id) {
      state.contents = state.contents.filter(c => c.content_id !== id)
      storage.set(STORAGE_KEY, state.contents)
    }
  },
  getters: {
    allContents: state => state.contents,
    contentsByType: state => type => state.contents.filter(c => c.type === type && c.status === 1),
    contentsByRiskLevel: state => (type, riskLevel) => state.contents.filter(c =>
      c.type === type && c.status === 1 && (c.risk_level === 0 || c.risk_level === riskLevel)
    ),
    // 根据风险等级 + 行为关键词匹配内容（反馈16）
    contentsByRiskAndKeywords: state => (type, riskLevel, behaviorKeywords = []) => {
      const baseList = state.contents.filter(c =>
        c.type === type && c.status === 1 && (c.risk_level === 0 || c.risk_level === riskLevel)
      )
      if (!behaviorKeywords.length) return baseList
      // 优先返回有标签匹配的内容，按匹配度排序
      // 匹配逻辑：如果某个关键词出现在任一行为描述/类别名中，则算命中
      const keywordMatchCount = (keywords) => {
        return keywords.filter(k => behaviorKeywords.some(b => b.includes(k))).length
      }
      return baseList.sort((a, b) => {
        const aMatch = keywordMatchCount(a.keywords || [])
        const bMatch = keywordMatchCount(b.keywords || [])
        return bMatch - aMatch
      })
    }
  }
}
